import React from 'react';
import { Grid } from '@mui/material';
import SubHeaderDetails from 'components/subHeaderDetails/SubHeaderDetails';
import SubHeader from 'components/subHeader/SubHeader';

function HeaderSubVendor(props) {
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className="profilevendorMain"
      >
        <SubHeader details={props?.details} type ={props?.type} onClickStatusIcon={props.onClickStatusIcon} loader={props?.loader} statusChange={props?.statusChange}/>

        {/* ---2nd section--- */}
        {props?.type !== 'Vehicle' && <SubHeaderDetails type={props?.type} editData={props?.editData} onSubmittBtn={props?.onSubmittBtn} details={props?.details} loader={props?.loader} editIconFalse={props?.editButton}/>}
      </Grid>
    </div>
  );
}

export default HeaderSubVendor;
